import styled, { css, DefaultTheme } from "styled-components";
import { ButtonSizes } from "../../core/Button/Button";

type StyledButtonsTypProps = {
  $size?: ButtonSizes;
};

/* variants */

const variantStyles = (
  theme: DefaultTheme,
  size: ButtonSizes = ButtonSizes.REGULAR,
) =>
  ({
    regular: css`
      font-family: ${theme.variables.font_family};
      font-size: ${theme.variables.fs_16};
    `,
    small: css`
      font-family: ${theme.variables.font_family};
      font-size: ${theme.variables.fs_14};
    `,
  })[size];

const StyledButtonsTyp = styled.span<StyledButtonsTypProps>`
  ${({ theme, $size: size }) => variantStyles(theme, size)}
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export { StyledButtonsTyp };
